var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.buttonType === 'link')?_c('a',{staticClass:"main-button",class:{ secondary: _vm.isSecondary, disabled: _vm.isDisabled },attrs:{"href":_vm.buttonLink,"target":_vm.buttonTarget}},[_c('div',{staticClass:"button-content"},[_vm._t("default")],2)]):_c('button',{staticClass:"main-button",class:{
    secondary: _vm.isSecondary,
    disabled: _vm.isDisabled,
    switch: _vm.buttonType === 'switch',
    selected: _vm.buttonType === 'switch' && _vm.isActive,
  },attrs:{"disabled":_vm.isLoading || _vm.isDisabled,"type":_vm.buttonType === 'submit' ? 'submit' : 'button'}},[_c('transition',{attrs:{"mode":"out-in"}},[(_vm.isLoading)?_c('Loading',{attrs:{"fontSize":"8px"}}):_c('div',{staticClass:"button-content"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }